export default class Request
{
	static init(holiday)
	{
		let now = Number(new Date()) / 1000
		now -= now % 86400

		const picker = $('input.ui-datetime-picker')

		// noinspection JSUnusedGlobalSymbols
		picker.daterangepicker({
			locale             : {
				format     : 'YYYY-MM-DD HH:mm',
				daysOfWeek : ['日', '月', '火', '水', '木', '金', '土'],
				monthNames : ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
				cancelLabel: '削除',
				applyLabel : '選択',
			},
			autoUpdateInput    : false,
			singleDatePicker   : true,
			timePicker         : true,
			timePicker24Hour   : true,
			timePickerIncrement: 30,
			minYear            : 2021,
			drops              : 'up',
			isInvalidDate      : (date) =>
			{
				for(const day of holiday) if(day === date.weekday()) return true
				return date.unix() < now + 86400 * 3
			},
		})

		picker.on('apply.daterangepicker', function(event, picker)
		{
			const time = picker.startDate.format('YYYY-MM-DD HH:mm')
			$(this).val(time)

			const index = $(this).data('index')
			this.form.querySelector(`input[name="time${index}"]`).value = time
		})

		picker.on('cancel.daterangepicker', function()
		{
			$(this).val('')

			const index = $(this).data('index')
			this.form.querySelector(`input[name="time${index}"]`).value = ''
		})
	}

	static send_request(form, confirm_page = false)
	{
		return App.common.Network.form_post(form, (success) =>
		{
			if(!success || !confirm_page) return

			document.cookie = `time1=${form.time1.value}; path=/`
			document.cookie = `time2=${form.time2.value}; path=/`
			document.cookie = `time3=${form.time3.value}; path=/`

			document.cookie = `shop=${form.shop.value}; path=/`
			document.cookie = `coupon=${form.coupon.value}; path=/`

			const time = form.time1.value + '_' + form.time2.value + '_' + form.time3.value
			window.location.href = window.location.href.replace(/\/request\//, '/confirm/') + `//${time}`
		})
	}
}
